//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'
import hasGalleries from '~/mixins/hasGalleries'
import Gallery from '~/models/Gallery'

export default {
  mixins: [hasGalleries],

  data() {
    return { Gallery, galleries: [], isLoading: false, lastMeta: null }
  },

  beforeMount() {
    this.load()
  },

  methods: {
    async load() {
      try {
        const page = ((this.lastMeta && this.lastMeta.current_page) || 0) + 1
        const params = { limit: 12, orderBy: 'priority', page }
        this.isLoading = true

        await this.fetchGalleries(params)

        const galleries = this.getGalleries(params)
        this.galleries = page > 1 ? this.galleries.concat(galleries) : galleries
        this.lastMeta = get(this.getGalleriesResult(params), 'meta')
      } finally {
        this.isLoading = false
      }
    },
  },
}
